import * as React from 'react'
import Spinner from '../../components/Spinner'
import { SortDecision } from './types'

interface Props {
  variant: SortDecision
  loading?: boolean
}

export const ScanButton: React.FC<Props> = ({ variant, loading = false }) => {
  const onClick = () => {
    // TODO: Implement button click functionality
  }

  const imageMap = {
    ecommerce: '/ecommerce.svg',
    hot_list: '/scan.svg',
    store: '/store.svg',
    salvage: '/salvage.svg',
    reject: '/store.svg',
    multipleResults: '/scan.svg'
  }

  const textMap = {
    ecommerce: 'E-commerce',
    hot_list: 'Hot List',
    store: 'Sell in Store',
    salvage: 'Salvage',
    multipleResults: 'Multiple results',
    reject: 'Sell in Store'
  }

  if (loading)
    return (
      <button
        type="submit"
        className="scan-books-button"
        style={{
          backgroundImage: `url('/scan.svg')`
        }}
        onClick={onClick}
      >
        <Spinner size={24} />
      </button>
    )

  return (
    <button
      type="submit"
      className="scan-books-button"
      onClick={onClick}
      style={{
        backgroundImage: `url(${imageMap[variant]})`
      }}
    >
      {variant !== 'scan' && (
        <span
          className={`scan-books-button-text ${
            variant === 'store' || variant === 'ecommerce' || variant === 'reject' || variant === 'accept'
              ? 'text-white'
              : ''
          }`}
        >
          {textMap[variant]}
        </span>
      )}
    </button>
  )
}
